<template>
  <span v-if="pending" class="text-body-secondary fst-italic">
    {{ $t("dashboard.sales_transactions.pending_sales_details") }}
  </span>
  <slot v-else />
</template>

<script setup lang="ts">
defineProps<{
  pending: boolean;
}>();
</script>
